import React from 'react';
import { useState } from 'react';

function AvertTable() {
  const [openMenuId, setOpenMenuId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [adverts, setAdverts] = useState([
    {
      id: 1,
      title: "CloseCarbon Joins Forces with Glo...",
      date: "12/06/2025",
      outlet: "Plan Vivo Registry",
      category: "Sustainable Brands & Services",
      isActive: false,
    },
    {
      id: 2,
      title: "New Mangrove Restoration Project...",
      date: "25/06/2025",
      outlet: "Global Footprint Network",
      category: "Partnership Spotlights",
      isActive: true,
    },
    {
      id: 3,
      title: "Switch to Renewable Energy with E...",
      date: "19/06/2025",
      outlet: "Netzence",
      category: "Verified Offsets & Projects",
      isActive: true,
    },
    {
      id: 4,
      title: "Switch to Renewable Energy with E...",
      date: "11/06/2025",
      outlet: "Plan Vivo Registry",
      category: "Earn & Save",
      isActive: false,
    },
    {
      id: 5,
      title: "Switch to Renewable Energy with E...",
      date: "02/06/2025",
      outlet: "Netzence",
      category: "Climate Impact Stories",
      isActive: true,
    },
    {
      id: 6,
      title: "Switch to Renewable Energy with E...",
      date: "02/06/2025",
      outlet: "Netzence",
      category: "Climate Impact Stories",
      isActive: false,
    },
    {
      id: 7,
      title: "Switch to Renewable Energy with E...",
      date: "02/06/2025",
      outlet: "Netzence",
      category: "Climate Impact Stories",
      isActive: true,
    },
    {
      id: 8,
      title: "Switch to Renewable Energy with E...",
      date: "12/06/2025",
      outlet: "Netzence",
      category: "Verified Offsets & Projects",
      isActive: true,
    }
  ]);

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const toggleAdvertStatus = (id) => {
    setAdverts((currentAdverts) =>
      currentAdverts.map((advert) =>
        advert.id === id ? { ...advert, isActive: !advert.isActive } : advert
      )
    );
    setOpenMenuId(null);
  };

  // Filter adverts based on search term
  const filteredAdverts = adverts.filter(advert =>
    advert.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    advert.outlet.toLowerCase().includes(searchTerm.toLowerCase()) ||
    advert.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className='mt-20 ml-20'>
      {/* Filter Section */}
      <div className='flex justify-between items-center'>
        {/* Search */}
        <div className='bg-[#FAFAFA] w-[384px] h-[40px] rounded-[8px] px-5 flex items-center gap-3'>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0">
            <path d="M10.7683 18.3002C9.27899 18.3002 7.82314 17.8586 6.58484 17.0312C5.34654 16.2038 4.3814 15.0278 3.81147 13.6518C3.24154 12.2759 3.09242 10.7619 3.38297 9.30121C3.67352 7.84053 4.39068 6.49881 5.44377 5.44572C6.49686 4.39263 7.83858 3.67547 9.29925 3.38492C10.7599 3.09438 12.274 3.2435 13.6499 3.81342C15.0258 4.38335 16.2018 5.34849 17.0293 6.58679C17.8567 7.8251 18.2983 9.28094 18.2983 10.7702C18.2983 11.7591 18.1035 12.7383 17.7251 13.6518C17.3467 14.5654 16.792 15.3955 16.0928 16.0948C15.3936 16.794 14.5635 17.3486 13.6499 17.727C12.7363 18.1055 11.7571 18.3002 10.7683 18.3002ZM10.7683 4.75024C9.5816 4.75024 8.42156 5.10213 7.43486 5.76142C6.44817 6.42071 5.67913 7.35778 5.22501 8.45414C4.77088 9.55049 4.65206 10.7569 4.88357 11.9208C5.11508 13.0847 5.68653 14.1538 6.52564 14.9929C7.36476 15.832 8.43386 16.4034 9.59774 16.6349C10.7616 16.8665 11.968 16.7476 13.0644 16.2935C14.1607 15.8394 15.0978 15.0704 15.7571 14.0837C16.4164 13.097 16.7683 11.9369 16.7683 10.7502C16.7683 9.15894 16.1361 7.63282 15.0109 6.5076C13.8857 5.38238 12.3596 4.75024 10.7683 4.75024Z" fill="#667185"/>
            <path d="M20.0019 20.75C19.9034 20.7504 19.8057 20.7312 19.7147 20.6934C19.6237 20.6557 19.5412 20.6001 19.4719 20.53L15.3419 16.4C15.2094 16.2578 15.1373 16.0697 15.1407 15.8754C15.1442 15.6811 15.2229 15.4958 15.3603 15.3583C15.4977 15.2209 15.6831 15.1422 15.8774 15.1388C16.0717 15.1354 16.2597 15.2075 16.4019 15.34L20.5319 19.47C20.6724 19.6106 20.7513 19.8012 20.7513 20C20.7513 20.1987 20.6724 20.3893 20.5319 20.53C20.4627 20.6001 20.3801 20.6557 20.2891 20.6934C20.1981 20.7312 20.1005 20.7504 20.0019 20.75Z" fill="#667185"/>
          </svg>
          <input 
            className='w-full h-full bg-transparent outline-none text-sm placeholder:text-[#667185]'
            placeholder='Search'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Filter Button */}
        <div className='w-[85px] h-[40px] bg-[#FFFFFF] rounded-[1.5px] border-[1.5px] border-[#E5E5E5] flex items-center justify-center gap-2 cursor-pointer hover:bg-gray-50 transition-colors'>
          <span className='text-sm text-[#747474]'>Filter by</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.66536 6.66667L8.9987 10L12.332 6.66667" stroke="#747474" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      {/* Table */}
      <div className="w-[1112px] bg-white border-[0.7px] border-[#667185] rounded-xl overflow-hidden mt-10">
        {/* Table Header - Overview */}
        <div className="px-6 py-3.5">
          <span className="font-semibold text-[16px] text-black">Overview</span>
        </div>

        {/* Column Headers */}
        <div className="bg-[#FAFAFA] border-b border-[rgba(177,177,177,0.4)] flex items-center px-6 py-1">
          <div className="w-[236px] py-2.5 px-10">
            <span className="font-medium text-[12px] text-[#434343]">Title</span>
          </div>
          <div className="w-[95px] py-2.5">
            <span className="font-medium text-[12px] text-[#434343]">Date</span>
          </div>
          <div className="w-[166px] py-2.5">
            <span className="font-medium text-[12px] text-[#434343]">Advert Outlet</span>
          </div>
          <div className="w-[172px] py-2.5">
            <span className="font-medium text-[12px] text-[#434343]">Category</span>
          </div>
          <div className="w-[73px] py-2.5">
            <span className="font-medium text-[12px] px-10 text-[#434343]">Status</span>
          </div>
          <div className="w-[10px] py-2.5 px-32">
            <span className="font-medium text-[12px] text-[#434343]">Actions</span>
          </div>
        </div>

        {/* Table Rows */}
        {filteredAdverts.length > 0 ? (
          filteredAdverts.map((advert, index) => (
            <div 
              key={advert.id}
              className={`flex items-center px-10 py-10 border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                index === filteredAdverts.length - 1 ? 'border-b-0' : ''
              }`}
            >
              {/* Title */}
              <div className="w-[236px]">
                <span className="font-normal text-[12px] text-[#434343]">{advert.title}</span>
              </div>

              {/* Date */}
              <div className="w-[95px]">
                <span className="font-normal text-[12px] text-[#434343]">{advert.date}</span>
              </div>

              {/* Outlet */}
              <div className="w-[166px]">
                <span className="font-normal text-[12px] text-[#434343]">{advert.outlet}</span>
              </div>

              {/* Category */}
              <div className="w-[175px]">
                <span className="font-normal text-[12px] text-[#434343] tracking-[-0.005em]">
                  {advert.category}
                </span>
              </div>

              {/* Status */}
              <div className="w-[173px]">
                <span
                  className={`font-semibold text-[12px] px-10 ${
                    advert.isActive ? 'text-[#0D924F]' : 'text-[#667185]'
                  }`}
                >
                  {advert.isActive ? 'Active' : 'Non-active'}
                </span>
              </div>

              {/* Actions */}
              <div className="w-[120px] relative">
                <button 
                  onClick={() => toggleMenu(advert.id)}
                  className="w-6 h-6 flex items-center justify-center hover:bg-gray-100 rounded transition-colors"
                >
                  <div className="flex flex-col items-center gap-0.5">
                    <div className="w-1.5 h-1.5 bg-[#434343] rounded-full"></div>
                    <div className="w-1.5 h-1.5 bg-[#434343] rounded-full"></div>
                    <div className="w-1.5 h-1.5 bg-[#434343] rounded-full"></div>
                  </div>
                </button>

                {/* Dropdown Menu */}
                {openMenuId === advert.id && (
                  <div className="absolute top-8 left-0 w-[120px] bg-white border border-[#E5E5E5] rounded z-50 shadow-lg">
                    <div className="flex flex-col">
                      <button className="flex items-center px-3 py-2 border-b border-[#E5E5E5] hover:bg-gray-50 transition-colors w-full text-left">
                        <span className="text-[12px] text-[#898989]">Edit</span>
                      </button>
                      <button
                        onClick={() => toggleAdvertStatus(advert.id)}
                        className="flex items-center px-3 py-2 border-b border-[#E5E5E5] hover:bg-gray-50 transition-colors w-full text-left"
                      >
                        <span className="text-[12px] text-[#898989]">
                          {advert.isActive ? 'Deactivate' : 'Activate'}
                        </span>
                      </button>
                      <button className="flex items-center px-3 py-2 hover:bg-gray-50 transition-colors w-full text-left">
                        <span className="text-[12px] text-[#898989]">Delete</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="flex items-center justify-center py-12">
            <span className="text-sm text-[#667185]">No adverts found</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default AvertTable;